import { createIcon } from '@consta/icons/Icon'
import type { FC, SVGProps } from 'react'

const IconAddM: FC<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9.05882 2.88235C9.05882 2.39504 8.66378 2 8.17647 2C7.68916 2 7.29412 2.39504 7.29412 2.88235V7.29412H2.88235C2.39504 7.29412 2 7.68916 2 8.17647C2 8.66378 2.39504 9.05882 2.88235 9.05882H7.29412V13.1176C7.29412 13.605 7.68916 14 8.17647 14C8.66378 14 9.05882 13.605 9.05882 13.1176V9.05882H13.1176C13.605 9.05882 14 8.66378 14 8.17647C14 7.68916 13.605 7.29412 13.1176 7.29412H9.05882V2.88235Z" />
  </svg>
)

export const IconAdd = createIcon({
  name: 'IconAdd',
  l: IconAddM,
  m: IconAddM,
  s: IconAddM,
  xs: IconAddM,
})
